<div class="d-flex profile-media align-items-center" (click)="isShow =!isShow">
  <!--<img class="img-30" src="assets/images/dashboard/profile.png" alt="">-->
  <div class="flex-grow-1"><span>{{ 'settings' | translate }} <i class="fa fa-angle-down"></i></span>
    <!--<p class="mb-0 font-outfit">UI Designer<i class="fa fa-angle-down"></i></p>-->
  </div>
  <ul class="profile-dropdown onhover-show-div" [class.active]="isShow">
    <li>
      <a [routerLink]="'/pages/il-mio-profilo'">
          <!--<app-feather-icons [icons]="'user'"></app-feather-icons>-->
        <span>{{ 'routes.my_profile' | translate }}</span>
      </a>
    </li>
    <li>
      <a [routerLink]="'/pages/modifica-password'">
        <span>{{ 'routes.forgot_password' | translate }}</span>
      </a>
    </li>
  </ul>
</div>
